// Simple in-memory store to carry selected items across route navigation
// Note: Avoids serializing File/Blob through history state.
let items = [];

export function setPostExistingTripItems(nextItems) {
  items = Array.isArray(nextItems) ? nextItems : [];
}

export function getPostExistingTripItems() {
  return items || [];
}

export function clearPostExistingTripItems() {
  items = [];
}
